import React from 'react';
import { PropTypes as T } from 'prop-types';
import { Input } from 'reactstrap';

import BaseInput from '../base';

export class Option {
  constructor(value, label = value) {
    this.value = value;
    this.label = label;
  }
}

export class OptionGroup {
  constructor(label, options) {
    this.label = label;
    this.options = options;
  }
}

export default class BoundSelect extends BaseInput {
  static defaultProps = {
    ...BaseInput.defaultProps,
    multiple: false,
    options: [],
  };

  static propTypes = {
    ...BaseInput.propTypes,
    multiple: T.bool,
    options: T.arrayOf(T.oneOfType([T.instanceOf(Option), T.instanceOf(OptionGroup)])).isRequired,
  }

  static type = 'select';

  static mapOptionsToElementArray(options) {
    return options.reduce((els, o) => ([
      ...els,
      o instanceof OptionGroup ? (
        <optgroup label={o.label} key={o.label}>
          { this.mapOptionsToElementArray(o.options) }
        </optgroup>
      ) : (
        <option value={o.value} key={o.value}>
          { o.label }
        </option>
      ),
    ]), []);
  }

  render() {
    const {
      model,
      property,
      options,
      ...inputProps
    } = this.props;

    const name = inputProps.name || property;

    return (
      <Input
        {...inputProps}
        model={model}
        type={this.constructor.type}
        value={this.state.value}
        name={name}
        onChange={e => this.update(e.target.value)}
      >
        { this.constructor.mapOptionsToElementArray(this.props.options) }
      </Input>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/input/bound_select/index.jsx